// **React Imports
import React, { Suspense, memo } from 'react'
import { Navigate, Outlet, useParams } from 'react-router-dom'

// **Component Imports
import OverlayLoading from '../components/overlay-loading'
import ErrorBoundary from '../pages/error'

// **Utils Imports
import { getJWTToken, getUserDetails } from '../utils/utils'

const CandidateRestrictedRoute = () => {
  // Hooks
  const { contestUri } = useParams()

  //variables
  const jwt = getJWTToken()
  const userDetails = getUserDetails()

  return jwt && userDetails ? (
    contestUri ? (
      <Navigate to={`/c/${contestUri}/stages`} replace />
    ) : (
      <Navigate to={`/c`} replace />
    )
  ) : (
    <ErrorBoundary>
      <Suspense fallback={<OverlayLoading />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  )
}

export default memo(CandidateRestrictedRoute)
